/**
 * QR code + clé TOTP d'un enrôlement en cours. Les attributs data-qr-totp et
 * data-secret-totp servent aux preuves, qui MASQUENT ces deux éléments avant capture.
 */

import { useState } from 'react';
import { EnrolementTotp, formaterCleTotp } from './totp';

function BlocCleTotp({ enrolement }: { enrolement: EnrolementTotp }) {
  const [cleCopiee, setCleCopiee] = useState(false);

  async function copierCle() {
    try {
      await navigator.clipboard.writeText(enrolement.secret);
      setCleCopiee(true);
      setTimeout(() => setCleCopiee(false), 1800);
    } catch {
      // presse-papiers indisponible : la clé reste lisible à l'écran
    }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
        <img data-qr-totp src={enrolement.qrCode} alt="QR code de la double authentification" style={{ width: '180px', height: '180px', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '6px' }} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '8px 10px' }}>
        <code data-secret-totp style={{ flex: 1, fontSize: '13px', color: '#0f172a', letterSpacing: '0.5px', wordBreak: 'break-all' }}>{formaterCleTotp(enrolement.secret)}</code>
        <button type="button" onClick={copierCle} style={{ border: '1px solid #cbd5e1', backgroundColor: 'white', borderRadius: '6px', padding: '4px 10px', fontSize: '12px', cursor: 'pointer', color: '#334155' }}>
          {cleCopiee ? 'Copiée' : 'Copier'}
        </button>
      </div>
    </>
  );
}

export const ETAPES_ENROLEMENT = [
  'Ouvrez une application d’authentification (Google Authenticator, Microsoft Authenticator, 1Password…).',
  'Scannez le QR code, ou saisissez la clé à la main.',
  'Saisissez le code à 6 chiffres qu’elle affiche.'
];

export default BlocCleTotp;
